import { render, staticRenderFns } from "./DashboardButtonAction.vue?vue&type=template&id=5dddbc78"
import script from "./DashboardButtonAction.vue?vue&type=script&lang=js"
export * from "./DashboardButtonAction.vue?vue&type=script&lang=js"
import style0 from "./DashboardButtonAction.vue?vue&type=style&index=0&id=5dddbc78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports